import { values } from './enums'

const BiweekDay = {
  SUNDAY1: 0,
  MONDAY1: 1,
  TUESDAY1: 2,
  WEDNESDAY1: 3,
  THURSDAY1: 4,
  FRIDAY1: 5,
  SATURDAY1: 6,
  SUNDAY2: 7,
  MONDAY2: 8,
  TUESDAY2: 9,
  WEDNESDAY2: 10,
  THURSDAY2: 11,
  FRIDAY2: 12,
  SATURDAY2: 13
}

const VALUES = values(BiweekDay)

export {
  BiweekDay,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/BiweekDays.js